import useReceiptDetails from 'src/hooks/useReceiptDetails';

const ReceiptStatus = () => {
  const { receiptData } = useReceiptDetails();
  return (
    <div className="p-1 text-[13px]" title={receiptData?.receiptStatus}>
      <p className="font-bold pb-1 whitespace-nowrap">Status </p>
      <p className="pl-1">{receiptData?.receiptStatus}</p>
    </div>
  );
};

export default ReceiptStatus;
